import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { StoreTypename } from '@monorepo/shared/src/types';
import GET_CONTENT from '../../queries/books/get-content-query';

type BookContent = {
  id: number;
  pageNumber: number;
  value: string;
};

export type BookContentStoreState = {
  content: BookContent[];
  error: ApolloError | undefined;
  isLoading: boolean;
};

export type BookContentStore = [BookContentStoreState, Record<string, any>];

export const getDefaultBookContentStoreState = (): { __typename: string } => ({
  __typename: StoreTypename.RESOURCES,
});

const useBookContentStore = (bookId: number): BookContentStore => {
  const { data, loading, error }: QueryResult<{ bookContent: BookContent[] }> = useQuery(
    GET_CONTENT,
    {
      variables: { where: { id: bookId } },
    }
  );

  return [
    {
      content: data?.bookContent || [],
      error,
      isLoading: loading,
    },
    {},
  ];
};

export default useBookContentStore;
